import BeMaccaferriIdentityProvider from './BeMaccaferriIdentityProvider';

export const getUserNameAsync = BeMaccaferriIdentityProvider.getUserAsync;

export const logoutAsync = async () => {
    let response = await BeMaccaferriIdentityProvider.logoutAsync();
    window.location.href = process.env.REACT_APP_EDESIGN_PORTAL_URL as string;
    return response;
};
